import type { ReactNode } from 'react';

import MuiSpeedDial from '@mui/material/SpeedDial';
import SpeedDialIcon from '@mui/material/SpeedDialIcon';
import type { SxProps, Theme } from '@mui/material';

import { checkIfIsArray } from '@e-socna/utils';
import { EMPTY_ARRAY } from '@e-socna/empty';

import { Action, disabledProps } from './Action';
import type { SpeedDialAction } from './types/action.type';

export { disabledProps as speedDialActionDisabledProps };

interface Props {
  readonly title: string;
  readonly actions: readonly SpeedDialAction[];
  readonly icon?: ReactNode;
  readonly sx?: SxProps<Theme>;
}

export const SpeedDial = ({
  title,
  icon,
  actions,
  sx = EMPTY_ARRAY,
}: Readonly<Props>) => (
  <MuiSpeedDial
    ariaLabel={title}
    icon={icon ?? <SpeedDialIcon />}
    sx={[
      { position: 'fixed', bottom: 16, right: 16 },
      ...(checkIfIsArray(sx) ? sx : [sx]),
    ]}
  >
    {actions.map((action) => (
      <Action action={action} key={action.id} />
    ))}
  </MuiSpeedDial>
);
